<template>
  <div>
    <div class="handle-line">
      <!-- <div>
        <span class="select-label">类型</span>
        <el-select
          class="ml10 my-select mr20"
          v-model="type"
          filterable
          placeholder="请选择类型"
          @change="getData"
        >
          <el-option
            v-for="(v, i) in typeOptions"
            :key="i"
            :label="v.label"
            :value="v.value"
          />
        </el-select>
      </div> -->
      <!-- <div class="mt10 line">
        <span class="select-label">外圈</span>
        <el-radio-group
          class="ml10"
          v-model="radio"
        >
          <el-radio :label="1">日</el-radio>
          <el-radio :label="2">旬</el-radio>
          <el-radio :label="3">月</el-radio>
          <el-radio :label="4">年</el-radio>
          <el-radio :label="5">自定义时间</el-radio>
        </el-radio-group>
        <el-date-picker
          v-if="radio == 5"
          class="date-picker ml10"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          v-model="dataRange"
          value-format="yyyy-MM-dd"
          clearable
          type="daterange"
        ></el-date-picker>
      </div> -->
      <div class="mt10 line">
        <span class="select-label">中圈</span>
        <el-radio-group
          class="ml10"
          v-model="unitHydraulicAnalysisTimeType1"
        >
          <el-radio :label="1">日</el-radio>
          <el-radio :label="2">周</el-radio>
          <el-radio :label="3">月</el-radio>
          <el-radio :label="4">季</el-radio>
          <el-radio :label="5">年</el-radio>
        </el-radio-group>
        <!-- <el-date-picker
          v-if="radio == 5"
          class="date-picker ml10"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          v-model="dataRange"
          value-format="yyyy-MM-dd"
          clearable
          type="daterange"
        ></el-date-picker> -->
      </div>
      <div class="mt10 line">
        <span class="select-label">内圈</span>
        <el-radio-group
          class="ml10"
          v-model="unitHydraulicAnalysisTimeType2"
        >
          <el-radio :label="1">日</el-radio>
          <el-radio :label="2">周</el-radio>
          <el-radio :label="3">月</el-radio>
          <el-radio :label="4">季</el-radio>
          <el-radio :label="5">年</el-radio>
        </el-radio-group>
        <!-- <el-date-picker
          v-if="radio == 5"
          class="date-picker ml10"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          v-model="dataRange"
          value-format="yyyy-MM-dd"
          clearable
          type="daterange"
        ></el-date-picker> -->
      </div>
    </div>
    <div class="foot-btn">
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </div>
    <!-- <div class="content">
      <div class="box1">
        <div class="echart-box">
          <f-echart
            ref="allChart"
            id="fall"
            title="全厂机组"
          ></f-echart>
        </div>
      </div>
      <div class="box2">
        <div class="echart-box">
          <f-echart
            ref="f1Chart"
            id="fone"
            title="1号机组"
          ></f-echart>
        </div>
        <div class="echart-box">
          <f-echart
            ref="f2Chart"
            id="ftwo"
            title="2号机组"
          ></f-echart>
        </div>
        <div class="echart-box">
          <f-echart
            ref="f3Chart"
            id="fthree"
            title="3号机组"
          ></f-echart>
        </div>
      </div>
    </div> -->
    <model-login-detail
      title="登录"
      width="25%"
      ref="modelLoginDetailRef"
    />
  </div>
</template>

<script>
import { api } from '@/api/api'
import ModelLoginDetail from './ModelLoginDetail.vue'
// import FEchart from '../echartComponents/FEchart.vue'
export default {
  components: { ModelLoginDetail },
  data() {
    return {
      type: 1,
      unitHydraulicAnalysisTimeType1: 1,
      unitHydraulicAnalysisTimeType2: 2,
      dataRange: [],
      typeOptions: [{
        label: '效率',
        value: 1
      }, {
        label: '耗水率',
        value: 2
      }, {
        label: 'F值',
        value: 3
      }]
    }
  },
  methods: {
    submit() {
      if (this.unitHydraulicAnalysisTimeType1 == this.unitHydraulicAnalysisTimeType2) {
        return this.$message.warning('请选择不同时间维度')
      }
      let params = {
        url: api.updateSetting,
        data: {
          id: 1,
          unitHydraulicAnalysisTimeType1: this.unitHydraulicAnalysisTimeType1,
          unitHydraulicAnalysisTimeType2: this.unitHydraulicAnalysisTimeType2
        },
        token: localStorage.getItem('token')
      }
      this.$http.put(params).then((res) => {
        if(res.data.code == 200) {
          this.$emit('getParams', {
            unitHydraulicAnalysisTimeType1: this.unitHydraulicAnalysisTimeType1,
            unitHydraulicAnalysisTimeType2: this.unitHydraulicAnalysisTimeType2
          })
        }else if(res.data.code == 500) {
          this.$message.error(res.data.msg)
        }else {
          this.$message.error('连接超时')
          this.$refs.modelLoginDetailRef.show()
        }
      })
    },
    getData() {
      this.$http.get({ url: api.getSetting }).then(res => {
        this.unitHydraulicAnalysisTimeType1 = res.data.data.unitHydraulicAnalysisTimeType1
        this.unitHydraulicAnalysisTimeType2 = res.data.data.unitHydraulicAnalysisTimeType2
      })
    }
  }
}
</script>

<style scoped>
.handle-line /deep/ .el-radio__label {
  color: #fff !important;
}
.handle-line /deep/ .el-input--mini .el-input__inner {
  background: #0c2341 !important;
  border: 1px solid #1a4c89 !important;
  color: #fff !important;
}
.handle-line .data-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
.handle-line .my-select {
  width: 130px !important;
  background-color: #0c2342 !important;
}
.handle-line /deep/ .el-range-editor--mini .el-range-input {
  background: #0c2341 !important;
  color: #fff;
}
.handle-line .date-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
</style>

<style scoped lang="scss">
.handle-line {
  margin-bottom: 20px;
  // display: flex;
  // align-items: center;
  .line {
    display: flex;
    align-items: center;
  }
  .select-label {
    color: #fff;
    font-size: 14px;
    margin-left: 20px;
    line-height: 28px;
  }
}
.content {
  width: 100%;
  .box1 {
    display: flex;
    justify-content: center;
    width: 100%;
    .echart-box {
      width: 33%;
      height: 200px;
      margin-top: 20px;
    }
  }
  .box2 {
    display: flex;
    width: 100%;
    .echart-box {
      width: 33.33%;
      height: 200px;
      margin-top: 20px;
    }
  }
}
.foot-btn {
  text-align: end;
  margin-bottom: -30px;
}
</style>
